export const viewPremiumPayoutFilterState = () => ({
  page: 1,
  perPage: 999
})